import { isMobile } from '../../../../helpers';

export const jackpotAmountAnimationConfigs: { [key: string]: number } = {
  fadeDelay: 0.2,
  columnCount: 15,
  fadeDuration: 0.05,
  dotColumnIndex: 12,
  maxAnimDuration: 1.5,
  maxForcedCyclesCount: 5,
  symbolsCountInColumn: 11,
  fadeCountOnStartOrReset: 5,
  rowSpacing: isMobile() ? 20 : 18,
  maskHeight: isMobile() ? 21 : 17,
  maskWidth: isMobile() ? 122 : 154,
  columnSpacing: isMobile() ? 10 : 13,
  fontStyleSize: isMobile() ? 12 : 18,
  firstRenderOffsetsForInitAmountValue: 2,
};